import Grid from "@mui/material/Grid2";
import {Button, Paper, Table,TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, useTheme} from "@mui/material";
import {formatCurrency} from "../utils/formatters";

export const ActivateContainer = () => {
    const theme = useTheme();

    const data = [
        {title: 'SKUs with stagnant costs', impact: 160000, impactToDate: 25000, status: 'Escalate', exceptions: '32 SKUs', dateStarted: '10/5'},
        {title: 'Orders below target margins', impact: 120000, impactToDate: 125000, status: 'Complete', dateStarted: '9/6'},
        {title: 'Accounts stopped buying (churn)', impact: 110000, impactToDate: 35000, status: 'At Risk', exceptions: '8 Accounts', dateStarted: '8/26'},
        {title: 'SKUs with stagnant prices', impact: 110000, impactToDate: 95000, status: 'On Track', exceptions: '6 SKUs', dateStarted: '8/1'},
        {title: 'Rep discount benchmark', impact: 110000, impactToDate: 25000, status: 'On Track', exceptions: '3 Reps', dateStarted: '11/12'},
        {title: 'Accounts with stagnant prices', impact: 60000, impactToDate: 30000, status: 'On Track', exceptions: '2 Accounts', dateStarted: '8/14'},
        {title: 'Products below target margin', impact: 60000},
        {title: 'Discount exceptions', impact: 50000},
        {title: 'Unprofitable accounts', impact: 40000},
        {title: 'Price harmony', impact: 40000},
        {title: 'Unprofitable SKUs', impact: 40000},
        {title: 'Unprofitable Orders', impact: 20000},
        {title: 'Over-discounting', impact: 20000},
        {title: 'Price harmony - SKUs out of alignment', impact: 20000},
        {title: 'Underpriced products', impact: 20000},
        {title: 'Price discrepancies', impact: 20000},
        {title: 'Price outliers', impact: 10000}
    ];

    const buttonColorMap = {
        'Escalate': theme.palette.indicator.red,
        'Complete': theme.palette.button.lightblue,
        'At Risk': theme.palette.indicator.orange,
        'On Track': theme.palette.button.green
    }

    const headerBaseStyle = {
        border: '1px solid rgba(224, 224, 224, 1)',
        borderRight: 'none',
        position: 'sticky',
        top: 0,
        zIndex: 0
    };

    const SummaryPanel = () => {
        return (
            <Paper style={{...theme.palette.contentPanel, margin: 30, padding: 10}}>
                <Grid container justifyItems="center" spacing={0}>
                    <Grid size={2} display="flex" justifyContent="center">
                        <Typography variant="h6" align="center" fontWeight="bold" gutterBottom>
                            $450K
                        </Typography>
                    </Grid>
                    <Grid size={2} display="flex" justifyContent="center">
                        <Typography variant="h6" align="center" fontWeight="bold" color={theme.palette.indicator.green} gutterBottom>
                            $150K
                        </Typography>
                    </Grid>
                    <Grid size={2} display="flex" justifyContent="center">
                        <Typography variant="h6" align="center" fontWeight="bold" gutterBottom>
                            6
                        </Typography>
                    </Grid>
                    <Grid size={2} display="flex" justifyContent="center">
                        <Typography variant="h6" align="center" fontWeight="bold" color={theme.palette.indicator.green} gutterBottom>
                            4
                        </Typography>
                    </Grid>
                    <Grid size={2} display="flex" justifyContent="center">
                        <Typography variant="h6" align="center" fontWeight="bold" color={theme.palette.indicator.orange} gutterBottom>
                            1
                        </Typography>
                    </Grid>
                    <Grid size={2} display="flex" justifyContent="center">
                        <Typography variant="h6" align="center" fontWeight="bold" color={theme.palette.indicator.red} gutterBottom>
                            1
                        </Typography>
                    </Grid>
                    <Grid size={2} display="flex" justifyContent="center">
                        <Typography variant="h7" align="center" gutterBottom>
                            Opportunity<br/>Potential
                        </Typography>
                    </Grid>
                    <Grid size={2} display="flex" justifyContent="center">
                        <Typography variant="h7" align="center" gutterBottom>
                            Margin Recovered
                        </Typography>
                    </Grid>
                    <Grid size={2} display="flex" justifyContent="center">
                        <Typography variant="h7" align="center" gutterBottom>
                            Active Actions
                        </Typography>
                    </Grid>
                    <Grid size={2} display="flex" justifyContent="center">
                        <Typography variant="h7" align="center" gutterBottom>
                            On-Track
                        </Typography>
                    </Grid>
                    <Grid size={2} display="flex" justifyContent="center">
                        <Typography variant="h7" align="center" gutterBottom>
                            At Risk
                        </Typography>
                    </Grid>
                    <Grid size={2} display="flex" justifyContent="center">
                        <Typography variant="h7" align="center" gutterBottom>
                            Escalated
                        </Typography>
                    </Grid>
                </Grid>
            </Paper>
        );
    };

    const Row = ({idx, row}) => {
        const buttonColor = buttonColorMap[row.status];
        const textColor = row.status === 'Escalate' ? 'white' : 'inherit';
        return (
            <TableRow key={idx} hover>
                <TableCell>{row.title}</TableCell>
                <TableCell align="center">
                    <Button sx={{paddingTop: 0, paddingBottom: 0, backgroundColor: buttonColor, color: textColor}}>{row.status}</Button>
                </TableCell>
                <TableCell align="center">{row.dateStarted}</TableCell>
                <TableCell align="right">{formatCurrency(row.impact, true, true)}</TableCell>
                <TableCell align="right">{formatCurrency(row.impactToDate, true, true)}</TableCell>
                <TableCell align="center">{row.exceptions}</TableCell>
                <TableCell align="center"></TableCell>
            </TableRow>
        );
    };

    return (
        <div>
            <Grid container spacing={2}>
                <Grid size={12}>
                    <SummaryPanel/>
                    <Paper style={{...theme.palette.contentPanel, margin: 30, padding: 20}}>
                        <Typography variant="h6" gutterBottom>
                            Action Summary
                        </Typography>
                        <TableContainer>
                            <Table stickyHeader size="small" sx={{tableLayout: 'fixed'}}>
                                <TableHead>
                                    <TableRow>
                                        <TableCell align="left" sx={{...headerBaseStyle, width: '270px', backgroundColor: '#323D7230'}}>
                                            Action
                                        </TableCell>
                                        <TableCell align="center" sx={{...headerBaseStyle, width: '130px', backgroundColor: '#323D7230'}}>
                                            Execution Status
                                        </TableCell>
                                        <TableCell align="center" sx={{...headerBaseStyle, width: '130px', backgroundColor: '#323D7230'}}>
                                            Date Started
                                        </TableCell>
                                        <TableCell align="right" sx={{...headerBaseStyle, width: '140px', backgroundColor: '#323D7230'}}>
                                            Estimated Impact
                                        </TableCell>
                                        <TableCell align="right" sx={{...headerBaseStyle, width: '130px', backgroundColor: '#323D7230'}}>
                                            Impact To Date
                                        </TableCell>
                                        <TableCell align="center" sx={{...headerBaseStyle, width: '150px', backgroundColor: '#323D7230'}}>
                                            Exceptions
                                        </TableCell>
                                        <TableCell align="center" sx={{...headerBaseStyle, width: '120px', backgroundColor: '#323D7230'}}>
                                            Escalation
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {data.map((row, idx) => {
                                        return <Row idx={idx} row={row}/>
                                    })}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Paper>
                </Grid>
            </Grid>
        </div>
    );
};